import React, { useState } from 'react';
import { Card, Table, Tag, Typography, Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { poMilestoneService } from '@/services/poMilestone.service';
import { PO_MILESTONE_STATUS_COLORS } from '@/constants/poMilestoneTypes';
import { DocumentRefLink } from '@/components/DocumentRefLink';

const { Title } = Typography;

export const PoMilestoneRegisterPage: React.FC = () => {
  const [statusFilter, setStatusFilter] = useState<string | undefined>(undefined);

  const { data: rows = [], isLoading } = useQuery({
    queryKey: ['po-milestone-register', statusFilter],
    queryFn: () => poMilestoneService.register({ status: statusFilter }),
  });

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>PO Milestone Register</Title>
      <Card>
        <Select
          allowClear
          placeholder="Status"
          style={{ width: 180, marginBottom: 16 }}
          value={statusFilter}
          onChange={setStatusFilter}
          options={Object.keys(PO_MILESTONE_STATUS_COLORS).map((s) => ({ value: s, label: s }))}
        />
        <Table
          rowKey="id"
          loading={isLoading}
          scroll={{ x: 1100 }}
          dataSource={rows}
          columns={[
            {
              title: 'PO',
              render: (_, r) => (
                <DocumentRefLink
                  to={`/scm/procurement/purchase-orders/${r.purchase_order_id}`}
                  number={(r as { po_number?: string }).po_number}
                  id={r.purchase_order_id}
                />
              ),
            },
            { title: 'Supplier', render: (_, r) => (r as any).supplier_name ?? '—' },
            { title: '#', dataIndex: 'milestone_number', width: 50 },
            { title: 'Milestone', dataIndex: 'milestone_name' },
            { title: 'Type', dataIndex: 'milestone_type' },
            {
              title: 'Amount',
              dataIndex: 'milestone_amount',
              align: 'right',
              render: (v) => Number(v).toFixed(2),
            },
            {
              title: 'Expected',
              dataIndex: 'expected_date',
              render: (d) => (d ? dayjs(d).format('DD-MMM-YY') : '—'),
            },
            {
              title: 'Status',
              dataIndex: 'status',
              render: (s) => <Tag color={PO_MILESTONE_STATUS_COLORS[s] ?? 'default'}>{s}</Tag>,
            },
            {
              title: 'Invoiced',
              dataIndex: 'invoiced_value',
              align: 'right',
              render: (v) => Number(v ?? 0).toFixed(2),
            },
            {
              title: 'Paid',
              dataIndex: 'paid_value',
              align: 'right',
              render: (v) => Number(v ?? 0).toFixed(2),
            },
          ]}
        />
      </Card>
    </div>
  );
};

export default PoMilestoneRegisterPage;
